var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheveronLastRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5L16 12L9 19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 19.81362,19.277789 V 4.86558",
    stroke: "currentColor",
    strokeWidth: 2.01331,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "path687"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheveronLastRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cheveron-last-right.9cb03d8f.svg";
export { ForwardRef as ReactComponent };